export default __webpack_public_path__ + "static/media/38-MDSir-with_WEC-Service-Team.33409506.jpeg";